<div
  class="my-request--container"
  [class.my-request--container-dropdown-open]="openDropdownId !== null"
>
  <app-filter-panel
    [fields]="filterFields"
    [defaultExpanded]="false"
    (filterChange)="onFilterChange($event)"
    (clearFilters)="onClearFilters()"
  ></app-filter-panel>

  <div class="requests-table-wrapper">
    <div class="custom-table-container">
      <div *ngIf="loading" class="table-loading">
        <div *ngFor="let i of [1,2,3,4,5]" class="skeleton skeleton-text"></div>
      </div>

      <div *ngIf="!loading" class="custom-table-wrapper">
        <table class="custom-table">
          <thead>
            <tr>
              <th style="width: 3%"></th>
              <th style="width: 18%">Name</th>
              <th style="width: 13%">Type</th>
              <th style="width: 13%">Request Type</th>
              <th style="width: 12%">Status</th>
              <th style="width: 15%">{{ dateColumnLabel }}</th>
              <th style="width: 12%">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="displayedRequests.length > 0; else noDataRow">
              <ng-container *ngFor="let row of displayedRequests">
              <tr class="main-row" [class.dropdown-open]="isDropdownOpen(row)" [attr.data-request-id]="row.id">
                <td>
                  <button
                    type="button"
                    class="row-expand-toggle"
                    [class.expanded]="isRowExpanded(row.id)"
                    (click)="toggleExpansion(row.id)"
                    [attr.aria-expanded]="isRowExpanded(row.id)"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                </td>
                <td>{{ row.name }}</td>
                <td>
                  <div class="type-cell">
                    <img
                      *ngIf="getAssetTypeIconSrc(row.type)"
                      [src]="getAssetTypeIconSrc(row.type)"
                      [alt]="formatAssetTypeLabel(row.type)"
                      class="type-icon-img"
                    />
                    <svg
                      *ngIf="!getAssetTypeIconSrc(row.type)"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [innerHTML]="getAssetTypeIcon(row.type)"
                    ></svg>
                    <span>{{ formatAssetTypeLabel(row.type) }}</span>
                  </div>
                </td>
                <td>{{ row.requestType }}</td>
                <td>
                  <span [ngClass]="getStatusChipClass(row.status)">{{ getStatusLabel(row.status) }}</span>
                </td>
                <td>
                  <div class="date-cell">
                    <span class="date-part">{{ formatDatePart(getDateForStatus(row)) }}</span>
                    <span class="time-part">{{ formatTimePart(getDateForStatus(row)) }}</span>
                  </div>
                </td>
                <td>
                  <div
                    class="action-cell-wrapper"
                    [class.action-dropdown-open]="isDropdownOpen(row)"
                    (click)="$event.stopPropagation()"
                  >
                    <button
                      class="action-btn"
                      type="button"
                      appActionDropdownTrigger
                      [class.active]="isDropdownOpen(row)"
                      (click)="toggleActionDropdown($event, row)"
                    >
                      <span>Action</span>
                    </button>

                    <div
                      class="action-dropdown-menu action-dropdown-menu--fixed"
                      *ngIf="isDropdownOpen(row)"
                      [style.top.px]="dropdownPosition.top"
                      [style.left.px]="dropdownPosition.left"
                      [style.right.px]="dropdownPosition.right"
                      (click)="$event.stopPropagation()"
                    >
                      <ul class="dropdown-list">
                        <li class="dropdown-item">
                          <button class="dropdown-link" (click)="onActionClick('view', row)">
                            View
                          </button>
                        </li>
                        <li class="dropdown-item" *ngIf="canConverse(row)">
                          <button class="dropdown-link" (click)="onActionClick('conversation', row)">
                            Conversation
                          </button>
                        </li>
                        <li class="dropdown-item" *ngIf="row.status === 'pending'">
                          <button class="dropdown-link dropdown-link--danger" (click)="onActionClick('withdraw', row)">
                            Withdraw
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>

              <tr class="expansion-row" *ngIf="isRowExpanded(row.id)">
                <td colspan="7" class="expansion-cell">
                  <div class="row-expansion">
                    <div class="expansion-section">
                      <span class="expansion-title">Requested as</span>
                      <span class="expansion-value">{{ row.requestAs === 'Organisation' ? (row.organisation || 'N/A') : 'Individual' }}</span>
                    </div>
                    <div class="expansion-section">
                      <span class="expansion-title">Purpose</span>
                      <span class="expansion-value">{{ row.purpose || 'N/A' }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
            </ng-container>
            <ng-template #noDataRow>
              <tr class="no-data-row">
                <td colspan="7" class="table-empty">
                  No {{ getActiveStatusLabel() }} Data Found
                </td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>

      <p-paginator
        *ngIf="shouldShowPagination && !loading"
        [rows]="pagination.pageSize"
        [totalRecords]="pagination.totalItems"
        [first]="(pagination.currentPage - 1) * pagination.pageSize"
        [rowsPerPageOptions]="[]"
        (onPageChange)="onPageChange($event)"
        styleClass="table--paginator"
      ></p-paginator>
    </div>
  </div>
</div>
